import { render, staticRenderFns } from "./AssignGame.vue?vue&type=template&id=9c85f91c&scoped=true&"
import script from "./AssignGame.vue?vue&type=script&lang=ts&"
export * from "./AssignGame.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c85f91c",
  null
  
)

export default component.exports